import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IncidentsRoutingModule } from './incidents-routing.module';
import { RaiseIncidentFormComponent } from './components/raise-incident-form/raise-incident-form.component';
import { SharedModule } from '../../shared/shared.module';


@NgModule( {
    declarations: [RaiseIncidentFormComponent],
    exports: [
        RaiseIncidentFormComponent
    ],
    imports: [
        SharedModule,
        IncidentsRoutingModule
    ]
})
export class IncidentsModule { }
